module.exports = __webpack_public_path__ + "assets/img/downhill_race.67cf94ca.jpg";